/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useCallback, useMemo} from "react";

import {createStore as create} from "./createStore";
import {useToastStore} from "../Toast"
import {getServer} from './server';
import {DEVMODE} from "../../useAppConfigStore";


const server = getServer()

export const useApiStore = create((set) => ({
    asUser: null,
    setAsUser: (asUser) => set({asUser}),
}))

export function useApiCallback(method, path, options) {
    const {data, setLoading, setError, ignoreErrors, returnAll, opts, displayErrors = true} = options
    const errorToast = useToastStore(state => state.showError);
    const asUser = useApiStore(state => state.asUser);

    const _opts = useMemo(() => opts || {}, [opts])

    return useCallback((altdata=null, altOpts=null) => {
        const onDone = altOpts?.onDone || options?.onDone;
        let txdata = data
        if (altdata !== null) {
            txdata = altdata
        }
        if (!path) return () => {}
        setLoading && setLoading(true)
        const controller = new AbortController()
        let opts = {
            method: method,
            signal: controller.signal,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            mode: 'cors',
        }

        if (asUser) {
            console.log('X-As-User', asUser)
            opts.headers['X-As-User'] = asUser;
        }

        if (DEVMODE && !path.match(/^https?:/)) {
            opts.credentials = 'include'
        }

        if (_opts) {
            opts = {...opts, ..._opts}
        }

        if (txdata && opts.method !== 'GET') {
            if (txdata instanceof File) {
                // enabling file upload via formdata
                delete opts.headers['Content-Type']
                // opts.headers['Content-Type'] = 'application/octet-stream'
                // const formData = new FormData();
                // formData.append('file', txdata);
                opts.body = txdata
            } else {
                opts.body = JSON.stringify(txdata)
            }
        }
        let url = path.match(/^https?:/) ? path : server + path
        if (altdata && opts.method === 'GET') {
            url += '?' + new URLSearchParams(altdata).toString()
        }
        fetch(url, opts)
            .then((response) => {
                setLoading && setLoading(false)

                const disposition = response.headers.get('content-disposition');
                if (disposition?.startsWith('attachment')) {
                    process_file_download(response, disposition);
                    onDone && onDone(null);
                    return
                }

                const contenttype = response.headers.get('content-type');
                if (response.ok && contenttype !== 'application/json') {
                    console.log('response is ok, but its not json', response.headers)
                    onDone && onDone(true);
                    return
                }

                response.json().then(data => {
                    if (!response.ok && !ignoreErrors) {
                        data = JSON.stringify((data.hasOwnProperty('data')) ? data.data : data)
                        if (displayErrors) {
                            errorToast(data)
                        }
                        setError && setError(true)
                        return
                    }
                    if (onDone) {
                        setError && setError(false)
                        if (returnAll)
                            onDone(data)
                        else
                            onDone(data.data, txdata)
                    }
                }, (e) => {
                    setLoading && setLoading(false)
                    setError && setError(true)
                    console.error(e)
                })
            }, (e) => {
                setLoading && setLoading(false)
                if (!String(e).match('signal is aborted without reason')) // seriously GTFO
                    console.error(e)
            })

        return () => {
            console.log('aborting request', method, path, data)
            controller.abort()
        }
    }, [data, path, setLoading, method, asUser, _opts, options?.onDone, ignoreErrors, displayErrors, setError, errorToast,
        returnAll
    ])
}

const process_file_download = (response, disposition) => {

    let fileName = 'downloaded_file'; // Fallback name

    if (disposition && disposition.includes('filename=')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
        }
    }

    response.blob().then(blob => {
        const fileUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', fileName); // This preserves the download filename

        // Append to body, click, and cleanup
        document.body.appendChild(link);
        link.click();

        // Clean up to avoid memory leaks
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }, err => {
        console.error('blob file error', err)
    })
}
